module.exports = __webpack_public_path__ + "task-loader-bg.519d7712cc67398216e7.png";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/assets/img/task-loader-bg.png
// module id = ../../../../../src/assets/img/task-loader-bg.png
// module chunks = styles